import { SizeProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import * as icons from "./icons";

type Props = {
  icon: keyof typeof icons;
  size?: SizeProp;
  className?: string;
};

export const Icon = ({ icon, size = "1x", className }: Props) => {
  return <FontAwesomeIcon size={size} icon={icons[icon]} className={className} />;
};
